module.exports = {"230804007":"永安街道","230804008":"港湾街道","230804009":"和平街道","230804010":"山水街道","230804579":"前进区农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230804.json
// module id = 856
// module chunks = 0